import { Localized } from "@fluent/react"
import { LoadingButton } from "@mui/lab"
import { DialogTitle, DialogContent, Grid, TextField, Alert, DialogActions } from "@mui/material"
import { useState, useCallback } from "react"
import { AppId, AppTextFieldHandler } from "../../../app/appTypes"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { If } from "../../../app/If"
import { showSuccess } from "../../notifications/notificationsSlice"
import { selectActivityById, Activity } from "../activitiesSlice"
import { UpdateStepAction } from "../types"

export interface CreateCriteriaDialogFormProps {
    stepId: AppId
    close: () => void
    update: UpdateStepAction
}

export const CreateCriteriaDialogForm = ({ stepId, update, close }: CreateCriteriaDialogFormProps) => {
    const dispatch = useAppDispatch()
    const step = useAppSelector(state => selectActivityById(state, stepId)) as Activity
    const { acceptanceCriteria } = step
    const [description, setDescription] = useState("")

    const [error, setError] = useState<string | undefined>(undefined)
    const [saving, setSaving] = useState(false)

    const handleDescriptionChange: AppTextFieldHandler = useCallback(e => setDescription(e.target.value), [])

    const handleOKClick = async () => {
        if (description) {
            try {
                setSaving(true)
                await dispatch(update({ ...step, acceptanceCriteria: [...acceptanceCriteria, { description }] })).unwrap()
                close()
                dispatch(showSuccess("saved"))
            } catch (error) {
                setError("error")
                setSaving(false)
            }
        }
    }

    return <>
        <DialogTitle>
            <Localized id="activity-criteria-new">Nowe kryterium akceptacji</Localized>
        </DialogTitle>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField 
                        fullWidth
                        sx={{ marginTop: 2 }}
                        value={description}
                        inputProps={{ maxLength: 200 }}
                        onChange={handleDescriptionChange}
                        label={<Localized id="activity-criteria-description">Opis</Localized>}
                    />
                </Grid>
                <If condition={error !== undefined}>
                    <Grid item xs={12}>
                        <Alert severity="error">
                            <Localized id="error">Błąd</Localized>
                        </Alert>
                    </Grid>
                </If>
            </Grid>
        </DialogContent>
        <DialogActions>
            <LoadingButton loading={saving} onClick={handleOKClick}>
                <Localized id="ok">OK</Localized>
            </LoadingButton> 
            <LoadingButton loading={saving} onClick={close}>
                <Localized id="cancel">Anuluj</Localized>
            </LoadingButton> 
        </DialogActions>
    </>
}
